var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn border-0 px-5 fw-bold text-white",class:_vm.color,attrs:{"type":_vm.type,"disabled":(_vm.processing? true: false)},on:{"click":function($event){return _vm.$emit('clicked');}}},[_vm._v(_vm._s(_vm.text)+" "),(_vm.processing)?_c('i',{staticClass:"fas fa-spinner fa-spin"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }